/**
 * mfaMesajlari — MFA cevaplarının kullanıcıya gösterilen metni (backlog #640).
 *
 * Backend metni isteğin dilinde yazar ve `messageKey` ile gönderir (otp.* / mfa.*). Giriş sayfasında dil, istekten SONRA da değişebilir; bu yüzden
 * bilinen anahtarlar sayfanın kendi t() metniyle çizilir (dil düğmesine anında uyar), bilinmeyen anahtar için backend'in `message`'ı, o da yoksa
 * cevabın türüne göre genel bir metin gösterilir. Sır yok: kod, bilet ya da şifre hiçbir metne girmez.
 */
import { currentLocaleTag } from '../../../i18n';

const ANAHTAR = {
  'otp.kod_gecersiz': 'mfa.hata.kodGecersiz',
  'otp.cok_sik': 'mfa.hata.cokSik',
  'otp.sms_gonderilemedi': 'mfa.hata.smsGonderilemedi',
  'otp.kurulu_degil': 'mfa.hata.kuruluDegil',
  'mfa.telefon_gecersiz': 'mfa.hata.telefonGecersiz',
  'mfa.sifre_gerekli': 'mfa.hata.sifreGerekli',
  'mfa.sifre_hatali': 'mfa.hata.sifreHatali',
  'mfa.oturum_gecersiz': 'mfa.hata.oturumGecersiz',
  'mfa.yontem_sms_degil': 'mfa.hata.yontemSmsDegil',
  'mfa.telefon_kayitli_degil': 'mfa.hata.telefonKayitliDegil',
};

const TUR = {
  WRONG_CODE: 'mfa.hata.kodGecersiz',
  TICKET_GONE: 'mfa.hata.oturumGecersiz',
  TOO_SOON: 'mfa.hata.cokSik',
  UNAVAILABLE: 'mfa.hata.kuruluDegil',
  FORBIDDEN: 'mfa.hata.sifreHatali',
  BAD_REQUEST: 'mfa.hata.genel',
  ERROR: 'mfa.hata.genel',
};

/** Şimdiden `ISO` zamanına kalan dakika (en az 1); geçmişse ya da okunamıyorsa null. */
export function kalanDakika(iso) {
  const bitis = iso ? new Date(iso).getTime() : NaN;
  if (!Number.isFinite(bitis) || bitis <= Date.now()) return null;
  return Math.max(1, Math.ceil((bitis - Date.now()) / 60000));
}

/** "14:35" gibi, kullanıcının dilinde saat. Okunamıyorsa null. */
export function saatMetni(iso) {
  const d = iso ? new Date(iso) : null;
  if (!d || Number.isNaN(d.getTime())) return null;
  return d.toLocaleTimeString(currentLocaleTag(), { hour: '2-digit', minute: '2-digit' });
}

/** `ozet`: mfaService.ozetle() çıktısı. Kilit için kalan süre, yanlış kod için kalan hak eklenir. */
export function mfaMesaji(t, ozet) {
  if (!ozet) return t('mfa.hata.genel');
  if (ozet.kind === 'LOCKED' || ozet.messageKey === 'otp.kilitli') {
    const dakika = kalanDakika(ozet.lockedUntil);
    return dakika ? t('mfa.hata.kilitli', { dakika, saat: saatMetni(ozet.lockedUntil) || '' }) : t('mfa.hata.kilitliGenel');
  }
  if (ozet.kind === 'TOO_SOON' && ozet.retryAfterSeconds) return t('mfa.hata.cokSikSaniye', { saniye: ozet.retryAfterSeconds });
  if (ozet.kind === 'WRONG_CODE' && ozet.attemptsLeft !== null && ozet.attemptsLeft !== undefined) {
    return t('mfa.hata.kodGecersizHak', { hak: ozet.attemptsLeft });
  }
  const anahtar = ANAHTAR[ozet.messageKey];
  if (anahtar) return t(anahtar);
  return ozet.message || t(TUR[ozet.kind] || 'mfa.hata.genel');
}
